import { useRouter } from "next/router";
import React, { useContext, useEffect, useState, useTransition } from "react";
import { useForm } from 'react-hook-form'
import settingsModel from "../../models/settings.model";
import useSWR from 'swr'
import Heading from "../../components/Heading.js";
import Link from "next/link";
import SettingsLayout from "./SettingsLayout";
import Form from "react-bootstrap/Form";
const Page = function () {

    const router = useRouter()
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors,isSubmitting },
        setError,
        reset
    } = useForm();
    const { data, mutate } = useSWR('setting', async () => await settingsModel.list())
    console.log('data------', data)
    useEffect(() => {

        reset(data?.data);
    }, [data])


    const onSubmit = handleSubmit(async (data, event) => {
        const formData = new FormData(event.target);
        await settingsModel.create(formData).then((response) => {

            // router.push('/pages')
        }).catch(error => {
            console.log('error', error)
            setError('title', { type: 'required', message: error.response?.data?.errors?.title })
            console.log(data?.errors?.title)
        })
    });

    return (
        <>
            <SettingsLayout title="Settings">
                <h5 className="card-header">Mobile App Settings</h5>
                <div className="list-group list-group-flush">
                    <div className="list-group-item">
                        <div className="row align-items-center">
                            <div className="col">
                                <strong className="mb-0">Unusual activity notifications</strong>
                                <p className="text-muted mb-0">Donec in quam sed urna bibendum tincidunt quis mollis mauris.</p>
                            </div>
                            <div className="col-auto">
                                <div className="custom-control custom-switch">
                                    <Form>
                                        <Form.Check
                                            type="switch"
                                            id="custom-switch"
                                        />
                                    </Form>
                                    <span className="custom-control-label"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="list-group-item">
                        <div className="row align-items-center">
                            <div className="col">
                                <strong className="mb-0">Unauthorized financial activity</strong>
                                <p className="text-muted mb-0">Fusce lacinia elementum eros, sed vulputate urna eleifend nec.</p>
                            </div>
                            <div className="col-auto">
                                <div className="custom-control custom-switch">
                                    <Form>
                                        <Form.Check
                                            type="switch"
                                            id="custom-switch"

                                        />

                                    </Form>
                                    <span className="custom-control-label"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




            </SettingsLayout>
        </>
    );
};

export default Page;